export function formatCurrency(value: number | string, decimal: number = 0, prefix: string = 'kr '): string {
  const formatted = Number(value)
    .toFixed(decimal)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return prefix + formatted
}
